import { render, staticRenderFns } from "./StockHistory.vue?vue&type=template&id=ef6d8be0&"
import script from "./StockHistory.vue?vue&type=script&lang=js&"
export * from "./StockHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports